import styled from 'styled-components'
import React from 'react'
import PropTypes from 'prop-types'

const Icon = () => (
   <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="far"
      data-icon="angle-down"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 320 512"
   >
      <path
         fill="currentColor"
         d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z"
      ></path>
   </svg>
)

const ChevronContainer = styled.div`
   display: inline-block;
   width: 15px;
      & > svg {
      transform: ${ props => {
         switch (props.direction) {
            default:
            case 'up': return 'rotate(180deg);'
            case 'down': return 'rotate(0deg);'
            case 'left':  return 'rotate(90deg);'
            case 'right': return 'rotate(270deg);'
         }
      }
   }
`

export const Chevron = ({ direction }) => (
   <ChevronContainer direction={ direction }>
      <Icon/>
   </ChevronContainer>
)

export default Chevron

Chevron.propTypes = {
   /**
    * Point in what direction?
    */
   direction: PropTypes.oneOf(['up', 'right', 'down', 'left'])
}

Chevron.defaultProps = {
   direction: 'up'
}